import { Component, inject, Input } from '@angular/core';

// Services
import { NetworkService } from '../../../core/services/network/network.service';

@Component({
  selector: 'not-available-offline',
  templateUrl: './not-available-offline.component.html',
  standalone: false,
})
export class NotAvailableOfflineComponent {
  @Input() featureNotAvailable: string = undefined;

  private readonly network = inject(NetworkService);

  get isBlockedApp(): boolean {
    return this.network.blockedApp;
  }

  get internetAvailable(): boolean {
    return this.network.connected;
  }
}
